<nb-menu tag="sideMainMenu" [items]="menu" class="main-sidebar-menu"></nb-menu>
